import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import React, { useState } from "react"

import { Button } from "components"

import DashboardWrapper from "components/new-stuff/ui/DashboardWrapper"

import { TopActionBar } from "components/new-stuff/ui/TopActionBar"
import { useAuthStore } from "stores"
import { useQuery } from "@tanstack/react-query"
import { walletAxiosInstance } from "utils/request"
import { walletBaseUrl } from "utils/newbaseurl"
import AddBeneficiary from "./modal/AddBeneficiary"
import { BenITem, IBeneficiaries } from "./interface"
import { useNavigate } from "react-router-dom"
import DeleteBeneficiary from "./modal/DeleteBeneficiary"
import { AppTable, TableActionMenu } from "components/new-stuff/app-table"

const CurrencyBeneficiaries = () => {
  const navigate = useNavigate()
  const [search, setSearch] = useState("")
  const { user } = useAuthStore()
  const [addModal, setAddModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [beneficiaryId, setBenId] = useState("")
  const walletId = user?.organisationWalletId
  const { isLoading: isLoadingBeneficiaries, data: beneficiariesData } =
    useQuery<IBeneficiaries>({
      queryKey: [
        `${walletBaseUrl}/v1/wallets/${walletId}/transfer-beneficiaries`,
      ],
      queryFn: async () => {
        const res = await walletAxiosInstance.get(
          `/v1/wallets/${walletId}/transfer-beneficiaries`
        )
        return res.data
      },

      // keepPreviousData: true,
      refetchOnWindowFocus: false,
      cacheTime: 24 * 60 * 60 * 1000,
      onSuccess: (data: any) => {
        console.log(data)
      },
    })
  const TableData = beneficiariesData?.data?.filter((item) => {
    if (!search) {
      return true
    }

    const searchValue = search.toLowerCase()

    return (
      item.accountName?.toLowerCase().includes(searchValue) ||
      item.bankName?.toLowerCase().includes(searchValue)
    )
  })
  const columns =
    [
      {
        title: "Beneficiary",
        dataIndex: "accountName",
      },
      {
        title: "Bank",
        dataIndex: "bankName",
      },
      {
        title: "Account number",
        dataIndex: "accountNumber",
        className: "mp-mask",
      },
      {
        title: "Type",
        dataIndex: "type",
        className: "capitalize",
      },
      {
        dataIndex: "actions",
        title: "",
        // The shared row action. Delete is marked as destructive, so it always sits behind the
        // menu's extra step rather than being one click away in every row.
        render: (_: any, record: BenITem) =>
          record ? (
            <TableActionMenu
              menu={{
                items: [
                  {
                    key: "send",
                    label: "Send money",
                    onClick: () =>
                      navigate(
                        record?.type === "bank"
                          ? `/employee/dashboard/wallet/send-money-bank?x=${record?._id}`
                          : `/employee/dashboard/wallet/send-money-wallet?x=${record?._id}`
                      ),
                  },
                  {
                    key: "delete",
                    label: "Delete",
                    danger: true,
                    onClick: () => {
                      setDeleteModal(true)
                      setBenId(record?._id)
                    },
                  },
                ],
              }}
            />
          ) : null,
      },
    ] || []

  return (
    <>
      <TopActionBar>
        <div className=" flex justify-between items-center w-full">
          <div className="border-2  h-8  rounded-5px w-[268px] flex  items-center px-2 bg-white ">
            <MagnifyingGlassIcon className=" text-neutral80 w-4" />
            <input
              placeholder="Search"
              className="bg-none w-full px-2 outline-none  text-sm h-7"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value)
              }}
            />
          </div>
          <Button
            color="primary"
            onClick={() => {
              setAddModal(!addModal)
            }}
          >
            Add Beneficiary
          </Button>
        </div>
      </TopActionBar>
      <DashboardWrapper>
        <div className="">
          <div className="bg-white  p-4 rounded-5px">
            <AppTable
              loading={isLoadingBeneficiaries}
              columns={columns}
              dataSource={TableData}
            />
          </div>
        </div>
      </DashboardWrapper>
      <AddBeneficiary
        modal={addModal}
        onClose={() => {
          setAddModal(!addModal)
        }}
      />
      <DeleteBeneficiary
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        beneficiaryId={beneficiaryId}
      />
    </>
  )
}
export default CurrencyBeneficiaries
